export const brandCompetitorEndPoint = `competitors`;
